import type { AnalysisState } from '@aibi/contracts';
import type { FieldCatalog } from './field-catalog';

const joinNames = (names: readonly string[]): string =>
  names.length <= 1 ? (names[0] ?? '') : `${names.slice(0, -1).join(', ')} y ${names.at(-1) ?? ''}`;

/**
 * Titulo de una tarjeta: el definido por el usuario (`layout.title`) o uno derivado de sus
 * campos ("Ventas por Categoria").
 */
export function cardTitle(card: AnalysisState, catalog: FieldCatalog): string {
  return card.layout.title ?? automaticTitle(card, catalog);
}

/** Titulo derivado de los campos, ignorando `layout.title`. */
export function automaticTitle(card: AnalysisState, catalog: FieldCatalog): string {
  const measures = card.measures.map((m) => m.label ?? catalog.get(m.measureId)?.name ?? m.key);
  const dimensions = card.dimensions.map(
    (d) => d.label ?? catalog.get(d.dimensionId)?.name ?? d.key,
  );
  if (measures.length === 0 && dimensions.length === 0) return 'Nueva visualizacion';
  if (dimensions.length === 0) return joinNames(measures);
  if (measures.length === 0) return joinNames(dimensions);
  return `${joinNames(measures)} por ${joinNames(dimensions)}`;
}
